module.exports = __webpack_public_path__ + "img/awake-bot-avatar.dcb02ee8.png";